import React from 'react';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { Button } from '../../../../../components/Button';
import {
  ResetUserPasswordResponse,
  ResetUserPasswordVariables,
  UserMutations,
} from '../../../../../../graphql/user.graphql';
import { useToast } from '../../../../../../providers/ToastProvider';
import { t } from '../../../../../../types/translation/Translator';
import { ToastType } from '../../../../../components/Toast';
import { Surface } from '../../../../../components/Surface';
import useMutation from '../../../../../../hooks/useMutation';
import { CompanyRoleAssignment } from '../../../../../../types/company_role_assignment';

interface UserUpdateManagementPasswordResetPaneProps {
  user: CompanyRoleAssignment;
}

export default function UserUpdateManagementPasswordResetSection({ user }: UserUpdateManagementPasswordResetPaneProps) {
  const { showToast } = useToast();

  const [resetUserPassword, { loading: resetUserPasswordLoading }] = useMutation<
    ResetUserPasswordResponse,
    ResetUserPasswordVariables
  >(UserMutations.resetUserPassword, {
    variables: { id: user.id },
    onCompleted: response => {
      showToast({
        type: ToastType.success,
        title: t(TranslationKey.userSettingsManagementResetUserPasswordEmailSentToastTitle).singular.upper,
      });
    },
  });

  return (
    <Surface>
      <div className='grid gap-4'>
        <div className='grid gap-2'>
          <p className='section-title'>
            {t(TranslationKey.userSettingsManagementResetUserPasswordTitle).singular.upper}
          </p>
          <p className='subtitle'>{t(TranslationKey.userSettingsManagementResetUserPasswordSubtitle).singular.upper}</p>
        </div>
        <Button
          text={t(TranslationKey.userSettingsManagementResetUserPasswordRequestAction).singular.upper}
          loading={resetUserPasswordLoading}
          disabled={false}
          className='w-fit'
          onClick={() => resetUserPassword()}
        />
      </div>
    </Surface>
  );
}
